import React from "react"
import "./chart.css"

export const PollSurveyNoRecord = () => {
    return(
        <div className="poll_survey_no_record">
            <div>Please Select other month!</div>
            <div>There is no record on selected month!</div>
        </div>
    )
}